import { useMemo } from 'react';
import { MutationState, useMutationState } from '@tanstack/react-query';

import { TaskResponse } from '../client';

export function useIsTaskMutating(taskId: string): boolean {
  const ongoingMutations = useMutationState<MutationState<unknown, Error, unknown, TaskResponse>>({
    filters: { status: 'pending' }, // Filter only ongoing mutations
  });

  return useMemo(() => {
    const ids = ongoingMutations.map((mutation) => mutation.context?.id || null);
    return ids.find((t) => t === taskId) !== undefined;
  }, [ongoingMutations, taskId]);
}
